import { Flex } from '@cognite/cogs.js';
import { StyledCommentContainer } from 'components/Comments/elements';
import { TextDetail } from 'components/Comments/UploadedComment/elements';
import { TextDetailSmall } from 'pages/Project/elements';
import React, { memo } from 'react';
import type { GroupedComments, Comment } from 'types';
import { toDisplayDate } from 'utils/date';
import {
  ReplyCommentAvatar,
  ReplyCommentThreadContainer,
  ReplyCommentWrapper,
} from './elements';

type ReplyCommentsThreadProps = {
  groupedComment: GroupedComments;
};

type ReplyCommentItemProps = {
  childComment: Comment;
};

const ReplyCommentItem = memo(({ childComment }: ReplyCommentItemProps) => {
  return (
    <ReplyCommentWrapper direction="column">
      <StyledCommentContainer
        role={childComment.role}
        aria-label={`child-comment-wrapper-${childComment.id}`}
      >
        <Flex direction="column" justifyContent="space-between">
          <Flex direction="row" alignItems="center" gap={5}>
            <ReplyCommentAvatar text={childComment.author} />
            <TextDetailSmall>
              {toDisplayDate(childComment.date, 'D.M.YYYY hh:mm a')}
            </TextDetailSmall>
          </Flex>
          <TextDetail>{childComment.commentContent}</TextDetail>
        </Flex>
      </StyledCommentContainer>
    </ReplyCommentWrapper>
  );
});

const ReplyCommentsThread = memo(
  ({ groupedComment }: ReplyCommentsThreadProps) => {
    return (
      <ReplyCommentThreadContainer direction="column">
        {groupedComment.children?.map((childComment: Comment) => (
          <ReplyCommentItem key={childComment.id} childComment={childComment} />
        ))}
      </ReplyCommentThreadContainer>
    );
  }
);

export default ReplyCommentsThread;
